import { Check, Ban, X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { LeadNumber } from "@/components/agents/configuration-server/stages/stageNav";
import { Button } from "@/components/ui/button";
import { DecisionCheckbox } from "@/components/agents/configuration-server/stages/DecisionRows";

/**
 * Cabeçalho do painel de pendentes: com itens marcados, as ações em lote; sem
 * nenhum, a dica de que dá para marcar vários.
 */
export function BulkActions({
  count,
  onApprove,
  onOutOfScope,
  onClear,
}: {
  count: number;
  onApprove: () => void;
  onOutOfScope: () => void;
  onClear: () => void;
}) {
  const { t } = useTranslation();
  if (count === 0) {
    return <span className="text-[13px] text-[var(--exed-ink-500)]">{t("Select items to decide in bulk")}</span>;
  }
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-[13px] text-[var(--exed-ink-500)]"><LeadNumber text={t("{{count}} selected", { count })} lead={String(count)} strongClassName="text-[var(--exed-ink-900)]" /></span>
      <Button size="sm" className="h-[34px] gap-1.5" onClick={onApprove}>
        <Check aria-hidden="true" className="h-3.5 w-3.5" />
        {t("Approve selected")}
      </Button>
      <Button size="sm" variant="outline" className="h-[34px] gap-1.5" onClick={onOutOfScope}>
        <Ban aria-hidden="true" className="h-3.5 w-3.5" />
        {t("Take selected out of scope")}
      </Button>
      <Button size="icon" variant="ghost" className="h-[34px] w-[34px]" aria-label={t("Clear selection")} title={t("Clear selection")} onClick={onClear}>
        <X aria-hidden="true" className="h-4 w-4" />
      </Button>
    </div>
  );
}

/** Barra "selecionar todos" sobre a lista de pendentes. */
export function SelectAllBar({
  checked,
  shown,
  onChange,
  disabled = false,
}: {
  checked: boolean | "indeterminate";
  shown: number;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3 border-b border-[var(--exed-card-border)] bg-[#fafbfc] px-5 py-2.5">
      <label className={`flex items-center gap-2.5 text-xs font-semibold text-[var(--exed-ink-900)] ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}>
        <DecisionCheckbox checked={checked} onChange={onChange} disabled={disabled} />
        {t("Select all")}
      </label>
      <span className="text-xs text-[var(--exed-ink-500)]">{t("{{shown}} shown", { shown: shown.toLocaleString("en-US") })}</span>
      <span aria-hidden="true" className="ml-auto font-mono text-[10px] uppercase tracking-[0.1em] text-[var(--exed-ink-500)]">{t("Decision")}</span>
    </div>
  );
}
